import { editStudent, fetchStudents, signUpStudent } from "./asyncThunks";

export const signUpStudentBuilder = (builder) => {
  builder.addCase(signUpStudent.pending, (state) => {
    state.signUpStudentPending = true;
  });
  builder.addCase(signUpStudent.fulfilled, (state, action) => {
    state.signUpStudentPending = false;
    state.students.data = [action.payload.student, ...state.students.data];
  });
  builder.addCase(signUpStudent.rejected, (state) => {
    state.signUpStudentPending = false;
  });
};

export const fetchStudentsBuilder = (builder) => {
  builder.addCase(fetchStudents.pending, (state) => {
    state.fetchStudentsPending = true;
  });
  builder.addCase(fetchStudents.fulfilled, (state, action) => {
    state.fetchStudentsPending = false;
    state.students.data = action.payload.data;
    state.students.total = action.payload.total;
    state.students.perPage = action.payload.perPage;
  });
  builder.addCase(fetchStudents.rejected, (state) => {
    state.fetchStudentsPending = false;
  });
};

export const editStudentBuilder = (builder) => {
  builder.addCase(editStudent.pending, (state) => {
    state.editStudentPending = true;
  });
  builder.addCase(editStudent.fulfilled, (state, action) => {
    state.editStudentPending = false;
    state.students.data = state.students.data.map((s) => {
      if (s.id === action.payload.student.id) {
        return action.payload.student;
      } else {
        return s;
      }
    });
  });
  builder.addCase(editStudent.rejected, (state) => {
    state.editStudentPending = false;
  });
};
